import { createStoreChunk } from '@core/store'

import { type TLosslessFormat } from '../helpers/getLosslessFormat'

type THqStoragePaywallState = {
    fileFormat: TLosslessFormat | null
}

export const hqStoragePaywallStore = createStoreChunk<THqStoragePaywallState>('hqStoragePaywall')({
    initialState: { fileFormat: null },
})
